import css from "standard/css";

const style = css`
  .avaliation {
    border-spacing: 0;
    width: 100%;

    .avaliation__thead {
      background-color: #013660;

      .avaliation__th {
        color: var(--color-master-lightest);
        font-family: var(--font-family-base);
        font-size: var(--font-size-xxs);
        font-weight: var(--font-weight-bold);
        line-height: var(--line-height-sm);
        padding: var(--spacing_inset-xs);
      }

      .avaliation__th:first-of-type {
        text-align: left;
        width: 60%;
      }
    }

    .avaliation__tbody {

      .avaliation__tr {
        background-color: var(--color-pure-white);
      }

      .avaliation__td {
        color: var(--color-master);
        font-family: var(--font-family-base);
        font-size: var(--font-size-xxs);
        font-weight: var(--font-weight-regular);
        line-height: var(--line-height-sm);
        padding: var(--spacing_inset-sm) var(--spacing_inset-xs);
        text-align: center;
      }

      .avaliation__td:first-of-type {
        text-align: left;
      }

      .avaliation__td:nth-of-type(3) span {
        background-color: var(--color-success);
        border-radius: var(--border-radius-pill);
        color: var(--color-master-lightest);
        font-family: var(--font-family-base);
        font-size: var(--font-size-xxs);
        font-weight: var(--font-weight-medium);
        line-height: var(--line-height-sm);
        padding: var(--spacing_inset-quarck) var(--spacing_inset-xs);
      }

      .avaliation__td:nth-of-type(3) strong {
        background-color: var(--color-danger);
        border-radius: var(--border-radius-pill);
        color: var(--color-master-lightest);
        font-family: var(--font-family-base);
        font-size: var(--font-size-xxs);
        font-weight: var(--font-weight-medium);
        line-height: var(--line-height-sm);
        padding: var(--spacing_inset-quarck) var(--spacing_inset-xs);
      }

      .avaliation__td:nth-of-type(4) button {
        background-color: var(--color-complete-dark);
        border: none;
        border-radius: var(--border-radius-sm);
        color: var(--color-master-lightest);
        font-family: var(--font-family-base);
        font-size: var(--font-size-xxs);
        font-weight: var(--font-weight-medium);
        line-height: var(--line-height-sm);
        padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
        cursor: pointer;
      }
    }
  }
`;

export default style;
